import React, { FunctionComponent } from 'react';
import {
  BlockProduct,
  BlockProductListSkeleton,
} from '@views/components/block/Block';

export const Placeholder: FunctionComponent<any> = () => (
  <BlockProduct>
    <BlockProduct.Body>
      <BlockProduct.List>
        <BlockProductListSkeleton />
      </BlockProduct.List>
    </BlockProduct.Body>
  </BlockProduct>
);

export default Placeholder;
